import React from 'react'
import { compose } from "redux";
// import hasUpdateProgram from "../../../hoc/hasUpdateProgram";
import toJS from "../../../hoc/toJS";
import OverlaySaveProgramComponent from "../presentational/OverlaySaveProgramComponent";
import { connect } from "react-redux";
import { programUpdateRequest, requestAllData } from "../../../actions";
import { push } from "connected-react-router";


const mapDispatchToProps = (dispatch, ownProps) => ({
    onGetProgram: () => {
        dispatch(requestAllData())
        dispatch(push(ownProps.goBackPath))
    },

    onUpdateProgramRedirect: ()  => {
        dispatch(programUpdateRequest())
        dispatch(push(ownProps.goBackPath))
    },
})

const OverlaySaveProgram = ({
    onGetProgram,
    onUpdateProgramRedirect
}) => {

    return <OverlaySaveProgramComponent
        titleTransId="program_save_overlay_title"
        textTransId="program_save_overlay_text"
        buttonPublishTransId="publish_program_button"
        buttonGetTransId="discard_program_button"
        onGetProgram={onGetProgram}
        onUpdateProgram={onUpdateProgramRedirect}
    />
}

export default compose(
    connect(null, mapDispatchToProps),
    toJS()
)(OverlaySaveProgram)